import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { readCookie } from '../../utils/Cookie';
import { setNewPassword } from '../actions/signinAction';
import { hideModal } from '../../actions/modal.js';
import { validatePassword } from '../../utils/inputValidator';
import { login } from '../actions/signinAction';
import { hideLoader } from '../../actions/shared/loader.js';
import { createRedirectUri } from '../../utils/redirectUtil';
import { gtmEventPush } from '../../modules/ga/GTMdatalayer';

class SetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      errorMsg: '',
      password: '',
      showTxt: false,
      showPwdClicked: false,
      hideTxt: false,
      redirectURI: ''
    };
  }

  componentDidMount() {
    const { queryString = '' } = this.props;
    const redirectURI = createRedirectUri(queryString);
    this.setState({ redirectURI });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { viewSiteAs, location: { pathname: source = '' } = {} } = this.props;
    const { redirectURI } = this.state;
    if (validatePassword(this.state.password) && this.state.password !== '') {
      this.setState({
        errorMsg: ''
      });
      var newPassObj = {};
      let userAccCredData = decodeURIComponent(readCookie('U'));
      newPassObj = {
        emailId: userAccCredData,
        newPass: this.state.password
      };
      this.props
        .setNewPassword(newPassObj, () => {
          if (this.props.newPwdStatus == 'SUCCESS') {
            var signInObj = {};
            signInObj = {
              username: userAccCredData,
              password: this.state.password
            };

            this.props.login(signInObj, () => {
              if (this.props.validUser) {
                if (viewSiteAs && viewSiteAs == 'desktop') {
                  if (source == '/login') {
                    window.location = redirectURI;
                  } else {
                    // close modal
                    this.props.hideModal('sign-in-up');
                    let { location: { href = '' } = {} } = window;
                    if (!href.includes('/cart')) {
                      window.location.reload();
                    }
                  }
                  // window.location.reload();
                } else {
                  window.location = redirectURI;
                }
                // eraseCookie("o");
                this.setState({
                  errorMsg: ''
                });
              }
            });
          } else {
            this.setState({
              errorMsg:
                'Password should have a minimum of 8 characters with atleast one number, one alphabet and one special character.'
            });
            let gaErr =
              'Error - Password should have a minimum of 8 characters with atleast one number, one alphabet and one special character.';
            ga('send', {
              eventCategory: 'Login',
              eventAction: 'Set Password',
              eventLabel: gaErr
            });
          }
        })
        .then(res => {
          if (res.status === 'FAILURE') {
            this.setState({
              errorMsg: res.desc
            });
            this.props.hideLoader('auth-modal-loader');
          }
        })
        .catch(err => {
          this.setState({
            errorMsg: err.desc
          });
        });
    } else {
      this.setState({
        errorMsg:
          'Password should have a minimum of 8 characters with atleast one number, one alphabet and one special character.'
      });
      let gaErr =
        'Error - Password should have a minimum of 8 characters with atleast one number, one alphabet and one special character.';
      ga('send', {
        eventCategory: 'Login',
        eventAction: 'Set Password',
        eventLabel: gaErr
      });
    }
  }

  handleGA = () => {
    gtmEventPush({
      event: 'link_click',
      screen_type: `Set New password`,
      link_text: `I'll do this later`,
      user_login_step: 3,
      page_type: 'login'
    });
  };

  showPwd(toggleState) {
    let inputPwd = document.getElementById('pwdInput');
    if (toggleState) {
      if (inputPwd.type == 'password') {
        inputPwd.type = 'text';
      }
    } else {
      inputPwd.type = 'password';
    }
  }

  render() {
    const {
      redirectURI = '',
      password = '',
      showPwdClicked = false,
      showTxt = false,
      hideTxt = false,
      errorMsg = ''
    } = this.state;
    const nameUser = decodeURI(readCookie('un'));
    const inputClassName = `login-form-inputs ${showPwdClicked ? 'show-pwd-otp' : ''}`;
    return (
      <div>
        <form
          className="login-form"
          onSubmit={this.handleSubmit}
          data-ga-event-category="Login"
          data-ga-event-action="Set password"
          data-ga-event-label="Screen Launch"
        >
          <h1> Set password </h1>
          <h3 className="login-form-inputs masked-cred">Hi {nameUser},</h3>

          <div>
            <label>
              {' '}
              Please set a new password
              <input
                type="password"
                name="password"
                id="pwdInput"
                className={inputClassName}
                placeholder=""
                size="32"
                maxLength="20"
                // autoFocus
                value={password}
                onChange={e => {
                  this.setState({
                    password: e.target.value,
                    showTxt: true
                  });
                }}
              />
              {/* Show and Hide password option */}
              {showTxt ? (
                <span
                  className="show-pwd"
                  onClick={e => {
                    let toggleState = !showPwdClicked;
                    this.setState({
                      showPwdClicked: toggleState,
                      hideTxt: !hideTxt
                    });
                    this.showPwd(toggleState);
                  }}
                >
                  {!hideTxt ? 'Show' : 'Hide'}
                </span>
              ) : null}
            </label>
            {/* Display error message when password is incorrect */}
            <div id="error-msg" className="error-msg" aria-live='polite'>
              {errorMsg}
            </div>
          </div>
          <div>
            <input type="submit" className="login-form-inputs login-btn" value="START SHOPPING" />
          </div>
          <div className="login-form-inputs btn-action-txt" onClick={this.handleGA}>
            <a href={redirectURI}>I&#39;ll do this later</a>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setNewPassword: (formData, callbackNewPwd) =>
      dispatch(setNewPassword(formData, callbackNewPwd)),
    hideModal: name => {
      dispatch(hideModal(name));
    },
    login: (formData, callback) => {
      dispatch(login(formData, callback));
    },
    hideLoader: loaderName => dispatch(hideLoader(loaderName))
  };
};

const mapStateToProps = (state, ownProps) => {
  const { signInReducer = {}, httpError = {} } = state;
  const { status = false, validUser = false } = signInReducer;
  const { error = {} } = httpError;
  const { statusCode = '' } = error;
  return {
    httpError,
    newPwdStatus: status,
    statusCode,
    validUser
  };
};

export default SetPassword = withRouter(connect(mapStateToProps, mapDispatchToProps)(SetPassword));
